import { Size } from '~/src/hooks/useSize';

import State, { size } from '../State';


export interface SetSize {
	tag : 'SetSize';
	val : Size;
}

export const setSize = ( val : Size ) : SetSize =>
	( { tag : 'SetSize' , val } );

export const exeSetSize = ( state : State , cmd : SetSize ) : State =>
	size( _ => cmd.val )( state );
